import Client from '../infra/http/AxiosClient';

export const getInfo = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get('/info');
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getLinks = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get('/linkscategory');
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getPublications = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get('/publicationcategories');
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getManagement = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get('/managementspage');
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getMembers = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get('/memberspage');
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getDynamicPage = id => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get(`/radiographerpages/${id}`);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const search = search => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get(`/info/search?content=${search}`);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/ContentService.js